/* eslint-disable @typescript-eslint/no-explicit-any */
import { Typography } from '@mui/material'
import Card from '@mui/material/Card'
import { Formik } from 'formik'
import React from 'react'

import content from './contents/MandatoryCheckContent'
import Form from './elements/Form'
import FormButton from './elements/FormButton'
import FormButtonContainer from './elements/FormButtonContainer'
import FormGrid from './elements/FormGrid'
import schema from './schemas/MandatoryCheckSchema'
import { MandatoryCheckDetailsProps } from '../../constants/types'

interface Props {
  user?: any
  mandatoryCheckDetails: MandatoryCheckDetailsProps
  updateData: (values) => any
  onCancel?: React.MouseEventHandler<HTMLButtonElement>
  editing?: boolean
  setLoading?: (value: boolean) => void
  displayError?: (values: any) => void
}

const MandatoryCheckForm: React.FC<Props> = ({
  user: initUser,
  mandatoryCheckDetails,
  updateData,
  editing,
  setLoading,
  onCancel,
  displayError,
}) => {
  if (
    !mandatoryCheckDetails.FIELD_REQ &&
    !('FIELD_LABEL' in mandatoryCheckDetails)
  ) {
    return (
      <>
        <Card>
          <Typography
            sx={{ m: 4 }}
            dangerouslySetInnerHTML={{
              __html: mandatoryCheckDetails?.CONTENT,
            }}
          />
        </Card>
        <FormButtonContainer wrap={false}>
          <FormButton secondary outlined onClick={onCancel}>
            Cancel
          </FormButton>
          <FormButton submit primary outlined onClick={updateData}>
            Next
          </FormButton>
        </FormButtonContainer>
      </>
    )
  }

  return (
    <Formik
      initialValues={{
        ...initUser,
        mandatoryCheckDetails,
      }}
      validateOnMount={editing}
      enableReinitialize
      validationSchema={schema}
      onSubmit={async (values, actions) => {
        setLoading(true)
        const [, error] = await updateData(values)

        if (error) {
          displayError({ title: error.title, message: error.message })
        }
        setLoading(false)
        actions.setSubmitting(false)
      }}>
      {(form) => {
        return (
          <Form id="mandatory-check-form">
            <>
              <Card>
                <Typography
                  sx={{ m: 4 }}
                  dangerouslySetInnerHTML={{
                    __html: mandatoryCheckDetails?.CONTENT,
                  }}
                />
                <FormGrid
                  content={content({
                    formDisabled: form.isSubmitting,
                    mandatoryCheckDetails,
                  })}
                />
              </Card>
            </>
            <FormButtonContainer wrap={false}>
              <FormButton
                secondary
                outlined
                onClick={onCancel}
                disabled={form.isSubmitting}>
                Cancel
              </FormButton>
              <FormButton
                submit
                primary
                outlined
                disabled={!form.isValid || form.isSubmitting}>
                {'Next'}
              </FormButton>
            </FormButtonContainer>
          </Form>
        )
      }}
    </Formik>
  )
}

export default MandatoryCheckForm
